<template>
  <div class="support-ticket-container">
    <header class="support-ticket-header">
      <div class="d-flex w-100 align-items-center justify-content-between">
        <div>
          <img
            v-if="getOrganizationDetails"
            :src="getOrganizationDetails.org_logo_url"
            height="auto"
            width="150"
          />
          <img
            v-else
            src="@/assets/img/logos/logo-dark.png" width="85"
          />
        </div>
      </div>
    </header>

    <div class="section-title text-center mb-4">{{ $t('supportticketing') }}</div>

    <div class="row support-ticket-additionl-details"
         v-if="TicketListByID_IsFirst.length"
    >
      <div class="col-6">
        <label class="mb-1">Category</label>
        <p>{{ selectedcategory }}</p>
      </div>
      <div class="col-6">
        <label class="mb-1">Ticket raised on:</label>
        <p>{{ TicketListByID_IsFirst[0].support_ticket_created_at | dateparse }}</p>
      </div>
      <div class="col-6">
        <label class="mb-1">Status:</label>
        <p>{{ TicketListByID_IsFirst[0].st_status }}</p>
      </div>

      <div class="col-12">
        <label class="mb-1">Ticket Query</label>
        <h5 class="mb-4">{{ TicketListByID_IsFirst[0].stm_subject }}</h5>
      </div>

      <div class="col-lg-12 col-xl-12 mb-4">
        <div
          v-for="(images, imagesIndex) in TicketListByID_IsFirst[0].UploadedImages"
          :key="imagesIndex"
          class="column"
        >
          <img :src="_GetImagePath(images)" alt/>
        </div>
      </div>

      <div v-if="TicketListByID_IsFirst.length > 0" class="col-12 p-3 border-bottom">
        <label class="mb-2">Ticket Responses:</label>
        <div class="row">
          <div class="col-1 pr-0">
            <img class="img-fluid" src="@/assets/img/icons/user-male.svg"/>
          </div>
          <div class="col-11">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <strong>{{ TicketListByID_IsFirst[0].st_creator_customer_email }}</strong>
              <small>{{ TicketListByID_IsFirst[0].support_ticket_created_at | dateparse }}</small>
            </div>
            <p class="mb-0">{{ TicketListByID_IsFirst[0].stm_comment }}</p>
          </div>
        </div>
      </div>

      <div
        v-for="(submsg, submsgIndex) in TicketListByID_SubMsgs"
        v-if="TicketListByID_SubMsgs.length > 0"
        :key="submsgIndex"
        class="col-12 p-3 border-bottom"
      >
        <div class="row">
          <div class="col-1 pr-0">
            <img class="img-fluid" src="@/assets/img/icons/user-male.svg"/>
          </div>
          <div class="col-11">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <strong>{{ submsg.fullName || TicketListByID_IsFirst[0].st_creator_customer_email }}</strong>
              <small>{{ submsg.stm_created_at | dateparse }}</small>
            </div>
            <p class="mb-0">{{ submsg.stm_comment }}</p>
          </div>
        </div>
      </div>

      <div class="col-12 p-3 border-bottom" v-if="allowResolve">
        <div class="dropdown-curve-container mr-2" v-if="!submittedForm">
          <label
            :class="
                  this.Users &&
                  this.Users.length > 0
                    ? 'shift-up'
                    : 'd-none'
                "
          >{{ $t("Reply as") }}</label
          >
          <multiselect
            :options="this.Users"
            :searchable="true"
            :placeholder="
                  this.selectedUserObj && this.selectedUserObj.fullName
                    ? this.selectedUserObj.fullName
                    : 'Select User'
                "
            :customLabel="setLabel"
            track-by="user_id"
            :allowEmpty="false"
            :showLabels="false"
            @select="
                  selectUser({
                    event: $event,
                    name: 'User',
                    user: $event
                  })
                "
          ></multiselect>
        </div>
      </div>

      <div id="resp" class="col-12 py-3">
        <textarea v-model="ticket_description"
                  v-if="!submittedForm"
                  :disabled="submittedForm || resolved"
                  class="form-control mb-2"
                  placeholder="Your Response...."
                  rows="3"
                  v-validate="'required'"
                  name="description"
                  id="description"
        >
        </textarea>
        <p v-if="submitted && errors.has('description')" class="error_message">
          <span>{{ errors.first("description")}}</span>
        </p>
        <!-- <button class="btn btn-blue w-100 mx-0">Submit</button> -->
        <div class="row mt-2" v-if="!submittedForm">
          <div class="col-6">
            <button
              :disabled="submittedForm"
              class="btn-blue"
              @click.prevent.stop="OnFinalSubmit('Open')"
            >Submit
            </button>
          </div>
          <div class="col-6"
               v-if="this.user_id || this.allowResolve"
          >
            <button
              :disabled="submittedForm"
              class="btn-blue"
              @click.prevent.stop="OnFinalSubmit('Close')"
            >Submit and Mark as Resolved
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/supportTicket.css";
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      submitted: false,
      submittedForm: false,
      status: null,
      statusenable: true,
      user_id: null,
      selecteduser: "",
      category_id: null,
      selectedcategory: "",
      ticket_subject: "",
      ticket_description: "",
      st_is_active: true,
      TicketCategoryList: [],
      stID: null,
      unique_id: null,
      TicketListByID_IsFirst: [],
      TicketListByID_SubMsgs: [],
      resolved: false,
      allowResolve: false,
      selectedUserObj: null,
      Users: [],
    };
  },
  beforeMount() {
    this.stID = this.$route.query.id;
    this.unique_id = this.$route.query.unique_id;
    this.status = this.$route.query.status;
    this.allowResolve =
      this.$route.query.allowResolve && this.$route.query.allowResolve === 'true'
        ?  true
        : false;

    let USINFO = this.secureStore.get("USINFO")

    if (USINFO || this.allowResolve) {
      this.cinema_id = USINFO ? USINFO.cinema_id : null;
      this.user_id = USINFO ? USINFO.user_id : null;

      if (USINFO)
        this.selecteduser =
          USINFO.first_name + " " + USINFO.middle_name &&
          USINFO.middle_name != null
            ? USINFO.middle_name
            : USINFO.first_name + " " + USINFO.last_name;

      this.getUsersList(this.cinema_id, this.user_id);
    }

    this.GetAllTicketsByID();
  },

  computed: {
    ...mapGetters(["getOrganizationDetails"]),
  },
  methods: {
    setLabel(x) {
      return `${x.first_name ? x.first_name : ''}${x.last_name ? ` ${x.last_name}` : ''}`
    },
    selectUser({user}) {
      this.selectedUserObj = user
    },
    getUsersList: function(cinema_id, user_id) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "users"
      });
      if (cinema_id) {
        body[cinema_id] = cinema_id;
      }
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;

            this.Users.map(x => {
              x.fullName = `${x.first_name ? x.first_name : ''}${x.middle_name ? ` ${x.middle_name}` : ''}${x.last_name ? ` ${x.last_name}` : ''}`
              if (String(user_id) === String(x.user_id)) {
                this.selecteduser = `${x.first_name} ${x.middle_name} ${x.last_name}`;
                this.user_id = x.user_id;
                this.selectedUserObj = x
                this.$forceUpdate()
              }
            });
          }
        })
        .catch(this._CatchError);
    },

    GetAllTicketsByID: function () {
      let payload = {st_id: this.unique_id};
      let loader = this.$loading.show();

      CinemasService.GetTickets(payload)
        .then(response => {
          const {data} = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              let Obj = data.Records;

              Obj.map(x => {
                if (x.stm_is_first == "Y") {
                  this.TicketListByID_IsFirst.push(x);
                  this.resolved = x.st_status !== 'Unresolved'
                  this.submittedForm = x.st_status !== 'Unresolved'
                  this.GetSupportTicketCategory(x.stc_id);
                }
              });

              let Obj2 = data.Records2;

              Obj2.map(x => {
                x.fullName = `${x.first_name ? x.first_name : ''}${x.middle_name ? ` ${x.middle_name}` : ''}${x.last_name ? ` ${x.last_name}` : ''}`

                if (x.stm_is_first == "N") {
                  this.TicketListByID_SubMsgs.push(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    GetSupportTicketCategory: function (id) {
      let payload = {
        limit: null,
        currentPage: null
      };

      MasterService.GetCategory(payload)
        .then(response => {
          const {data} = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TicketCategoryList = data.Records;

              this.TicketCategoryList.map(x => {
                if (id == x.stc_id) {
                  this.selectedcategory = x.stc_name;
                  this.category_id = x.stc_id;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    OnFinalSubmit: function (type) {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (valid) {
          this.submittedForm = true;

          let payload = {
            st_id: this.TicketListByID_IsFirst[0].st_id,
            description: this.ticket_description,
          };

          if(this.user_id) {
            payload.stm_responded_user_id = this.user_id
          }
          if(this.selectedUserObj) {
            payload.stm_responded_user_id = this.selectedUserObj.user_id
          }
          if(type === 'Close') {
            payload.ticket_status = 'Close'
          }

          console.log("payload :>> ", payload);

          CinemasService.RespondMycinemaSupportTicket(payload)
            .then(response => {
              const {data} = response;
                let reply = {
                  fullName: this.selecteduser || this.TicketListByID_IsFirst[0].st_creator_customer_email,
                  // st_id: this.stID,
                  // "stm_id": 0,
                  "stm_subject": "Follow-up",
                  "stm_comment": this.ticket_description,
                  "stm_created_at": moment().format("YYYY-MM-DD HH:mm:ss")
                }

                if (this.selectedUserObj)
                  reply.fullName = this.selectedUserObj.fullName

                this.TicketListByID_SubMsgs.push(reply)
                this.ticket_description = ''

              if (this.user_id)
                this.$toasted.show('Response submitted');
              else
                this.$toasted.show('Thank you for your feedback, we will get back to you soon.');
            })
            .catch(this._CatchError);
        }
        else {
          this.submittedForm = false
          this.$forceUpdate()
        }
      });
    }
  }
};
</script>

<style>
.msg-box {
  background-color: #e9ecef;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MycinemaSupportTicket/MycinemaSupportTicket.vue